import { Base2Presenter } from "core/presenter";
import { CustomerRepository, CompanyRepository } from "core/repository";

import * as FileSaver from "file-saver";
import { fn } from "util";

export default class CustomerPresenter extends Base2Presenter {
  initialState() {
    return {
      loading: false,
      filters: {
        name: "",
        email: "",
        identification: "",
        phone: ""
      },
      order: {
        field: "name",
        direction: "ASC"
      }
    };
  }

  async onDownload(format) {
    this.enqueue({ loading: true });

    switch (format) {
      case "csv":
        await this._downloadCSV();
        break;

      default:
        this.sendNotification({
          type: "error",
          title: "Oops...",
          content: "Ainda não suportamos esse formato"
        });
    }

    this.enqueue({ loading: false });
  }

  async _downloadCSV() {
    const currentUser = await this.mRuntime.get("currentUser");
    const company = await CompanyRepository.getOnline(currentUser.company_uuid);

    const repositoryResult = await CustomerRepository.getCustomerCsvContent(
      {
        order: [this.viewModel.order],
        filters: await this.getCustomerFilters()
      },
      company.data.customer_custom_fields
    );

    if (!repositoryResult.success && !company.success) {
      this.sendNotification({
        type: "error",
        title: "Ooopss...",
        content:
          "Não foi possível gerar o download do seu arquivo. Por favor tente novamente mais tarde.\nSe o problema persistir, entre em contato com o suporte."
      });
      return;
    }

    const content = repositoryResult.data;
    const contentBlob = new Blob([content], {
      type: "application/csv;charset=utf-8"
    });
    FileSaver.saveAs(contentBlob, "relatorio-de-clientes.csv");
  }

  async getCustomerFilters() {
    const { name, email, identification, phone } = this.viewModel.filters;
    const currentUser = await this.mRuntime.get("currentUser");

    const filters = [
      {
        connector: "AND",
        field: "company_uuid",
        operation: "EQ",
        value: currentUser.company_uuid
      },
      { connector: "AND", field: "deleted", operation: "NOT", value: true }
    ];

    if (!fn.isBlank(name)) {
      filters.push({
        connector: "AND",
        field: "name",
        operation: "LIKE",
        value: name
      });
    }
    if (!fn.isBlank(email)) {
      filters.push({
        connector: "AND",
        field: "email",
        operation: "LIKE",
        value: email
      });
    }
    if (!fn.isBlank(identification)) {
      filters.push({
        connector: "AND",
        field: "identification",
        operation: "LIKE",
        value: identification
      });
    }
    if (!fn.isBlank(phone)) {
      filters.push({
        connector: "AND",
        field: "phone",
        operation: "LIKE",
        value: phone
      });
    }

    return filters;
  }

  onChange(field, value) {
    this.enqueue(vm => ({
      filters: {
        ...vm.filters,
        [field]: value
      }
    }));
  }

  async onCreateCustomer() {
    this.navigateTo("app.registration.customer.create");
  }

  onGoManageFields() {
    this.navigateTo("app.registration.customer.manage");
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/customer/presenter.js